module.exports = __webpack_public_path__ + "static/pankaj-vaghela-portrait_dakshana-low-13be95cebae717ee8ad51fbbcab03b75.jpg";